import { useEffect, useState, useContext } from "react";
import "../../../../shared/css/Datatable.scss";
import { Link, useNavigate } from "react-router-dom";

import { DataGrid } from "@mui/x-data-grid";
import toast from "react-hot-toast";
import { useHttpClient } from "../../../../shared/hooks/http-hook";
import { AuthContext } from "../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../shared/context/clinica-context";
import { dadosImpressao } from "../../../../shared/util/dadosImpressao";

//Mui icons
import DeleteIcon from "@mui/icons-material/Delete";
//Delete icon
import ErrorIcon from "@mui/icons-material/Error";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import "../../../../shared/css/Datatable.scss";
import { useLoading } from "../../../../shared/context/LoadingContext";
//Antd
import { Popover, Space } from "antd";
import { Popconfirm } from "antd";

import { Printer } from "lucide-react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";

import PdfPrecario from "../../../../shared/components/PdfGenerator/pdfPrecario/PdfPrecario";
import "./DatatableTratamentos.scss";

function Datatable() {
  const { startLoading, stopLoading } = useLoading();

  const [data, setData] = useState();
  const [allData, setAllData] = useState();
  const { error, sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const navigate = useNavigate();

  const [openPrecarioDialog, setOpenPrecarioDialog] = useState(false);
  const [precarioConfig, setPrecarioConfig] = useState({
    data: new Date().toISOString().split("T")[0],
    instituicao: "particular",
    showPdf: false,
  });
  const [instituicoes, setInstituicoes] = useState([]);

  useEffect(() => {
    const fetchTratamentos = async () => {
      startLoading();
      try {
        let responseData;
        try {
          responseData = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentos/clinica/${clinica.clinica._id}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          );
        } catch (err) {
          console.error("err", err);
        }

        const todosTratamentos = responseData.tratamentos.map((tratamento) => {
          const precosInps = tratamento.precosPorInstituicao
            ? tratamento.precosPorInstituicao.find(
                (t) => t.instituicao?.nome === "INPS",
              )
            : 0;
          return {
            ...tratamento,
            preco_particular:
              Intl.NumberFormat("pt-BR").format(tratamento.preco_particular) +
              "$00",
            preco_segurado:
              Intl.NumberFormat("pt-BR").format(precosInps?.preco_segurado) ||
              0 + "$00",
            0:
              Intl.NumberFormat("pt-BR").format(
                precosInps?.comparticipacao || 0,
              ) + "$00",
            preco_beneficiario:
              Intl.NumberFormat("pt-BR").format(
                precosInps?.preco_beneficiario,
              ) + "$00",
          };
        });

        function naturalCompare(a, b) {
          const ax = [];
          const bx = [];

          (a.codigo || "").replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
            ax.push([$1 || Infinity, $2 || ""]);
          });
          (b.codigo || "").replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
            bx.push([$1 || Infinity, $2 || ""]);
          });

          while (ax.length && bx.length) {
            const an = ax.shift();
            const bn = bx.shift();
            const nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
            if (nn) return nn;
          }

          return ax.length - bx.length;
        }

        const tratamentosOrganizadosAlfabeticamente = todosTratamentos.sort(
          (a, b) => naturalCompare(a, b),
        );

        setData(tratamentosOrganizadosAlfabeticamente);
        setAllData(tratamentosOrganizadosAlfabeticamente);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchTratamentos();
  }, [sendRequest, clinica, auth.token]);

  useEffect(() => {
    const fetchInstituicoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/instituicoes/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setInstituicoes(responseData.instituicoes || []);
      } catch (err) {
        console.error("Erro ao buscar instituições:", err);
      }
    };
    if (clinica.clinica._id) {
      fetchInstituicoes();
    }
  }, [clinica.clinica._id, sendRequest, auth.token]);

  const handleDesativar = async (id) => {
    startLoading();
    try {
      const formDataDesativar = new FormData();
      formDataDesativar.append("utilizador", auth.userId);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentos/toggleativo/${id}`,
        "PATCH",
        formDataDesativar,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      setData(
        data.filter((el) => {
          return el.id !== id;
        }),
      );

      setAllData(
        data.filter((el) => {
          return el.id !== id;
        }),
      );

      toast.success("Tratamento eliminado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const findInpsPrices = (row) => {
    const dados = row.precosPorInstituicao
      ? row.precosPorInstituicao.find(
          (p) => p.coberto && p.instituicao?.nome === "INPS",
        )
      : null;
    return dados;
  };

  const handleOpenPrecarioDialog = () => {
    setOpenPrecarioDialog(true);
  };

  const handleClosePrecarioDialog = () => {
    setOpenPrecarioDialog(false);
    setPrecarioConfig({
      data: new Date().toISOString().split("T")[0],
      instituicao: "particular",
      showPdf: false,
    });
  };

  const handleGeneratePrecario = () => {
    setPrecarioConfig((prev) => ({ ...prev, showPdf: true }));
    setOpenPrecarioDialog(false);
  };

  const tratamentoColumns = [
    {
      field: "codigo",
      headerName: "Codigo",
      flex: 2,
    },
    {
      field: "designacao",
      headerName: "Tratamento",
      flex: 8,
      renderCell: (params) => {
        return (
          <span className="nomeDataTable">
            <Link to={`/tratamentos/${params.row.id}/edit`}>
              {params.row.designacao}
            </Link>
            {params.row.fornecedor?.nome ? (
              <span className="datatableTratamentos__fornecedor">
                {params.row.fornecedor.nome}
              </span>
            ) : null}
          </span>
        );
      },
    },
    {
      field: "preco_segurado",
      headerName: "Segurado (INPS)",
      flex: 3,
      renderCell: (params) => {
        return (
          <span className="nomeDataTable">
            {findInpsPrices(params.row)?.preco_segurado || "N/A"}
          </span>
        );
      },
    },
    {
      field: "comparticipacao",
      headerName: "Comp. INPS",
      flex: 3,
      renderCell: (params) => {
        return (
          <span className="nomeDataTable">
            {findInpsPrices(params.row)?.comparticipacao || "N/A"}
          </span>
        );
      },
    },
    {
      field: "preco_beneficiario",
      headerName: "Beneficiario (INPS)",
      flex: 3,
      renderCell: (params) => {
        return (
          <span className="nomeDataTable">
            {findInpsPrices(params.row)?.preco_beneficiario || "N/A"}
          </span>
        );
      },
    },

    {
      field: "preco_particular",
      headerName: "Particular",
      flex: 3,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Ações",
      flex: 1.5,
      renderCell: (params) => {
        const content = (
          <div className="dots__menu__popup">
            {auth.perm.includes("u-tr") && (
              <Link
                to={`/tratamentos/${params.row.id}/edit`}
                style={{ textDecoration: "none" }}
              >
                <div className="popOverMenu--option">
                  <span>Editar</span>
                  <EditIcon className="popOverMenu--option__icon" />
                </div>
              </Link>
            )}

            {auth.perm.includes("c-tr") && (
              <div
                className="popOverMenu--option"
                onClick={() =>
                  navigate(`/tratamentos/new?duplicar=${params.row.id}`)
                }
              >
                <span>Duplicar</span>
                <ContentCopyIcon className="popOverMenu--option__icon" />
              </div>
            )}

            {auth.perm.includes("d-tr") && (
              <Popconfirm
                title={`Excluir Tratamento`}
                description={`Pretende desativar ${params.row.designacao}?`}
                icon={<ErrorIcon style={{ color: "red" }} />}
                okText="Sim"
                cancelText="Não"
                onConfirm={handleDesativar.bind(null, params.row.id)}
              >
                <div className="popOverMenu--option">
                  <span>Desativar</span>
                  <DeleteIcon className="popOverMenu--option__icon" />
                </div>
              </Popconfirm>
            )}
          </div>
        );

        return (
          <div className="cellAction">
            <Space wrap>
              <Popover content={content} trigger="click" placement="bottom">
                <div className="dots__menu">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </Popover>
            </Space>
          </div>
        );
      },
    },
  ];

  const normalizeString = (str) => {
    return str
      .normalize("NFD") // Normalize to decomposed form
      .replace(/[\u0300-\u036f]/g, ""); // Remove combining diacritical marks
  };

  const searchHandler = (e) => {
    if (allData) {
      const searchQuery = normalizeString(e.target.value.trim().toLowerCase()); // Normalize and make the search query lowercase

      // Filter items that start with the search query
      const startsWithQuery = allData.filter((dt) =>
        normalizeString(dt.designacao).toLowerCase().startsWith(searchQuery),
      );

      // Filter remaining items that contain the search query
      const containsQuery = allData.filter(
        (dt) =>
          !normalizeString(dt.designacao)
            .toLowerCase()
            .startsWith(searchQuery) &&
          normalizeString(dt.designacao).toLowerCase().includes(searchQuery),
      );

      // Concatenate the results, with items starting with the search query first
      const result = startsWithQuery.concat(containsQuery);

      setData(result);
    }
  };

  return (
    <>
      {!error && data && (
        <>
          <div className="datatable caixa">
            {auth.perm.includes("c-tr") && (
              <div className="datatable__add-button-div datatable__add-button-div--clientes">
                <div className="search__datatable__container">
                  <span>Procurar</span>
                  <input
                    type="search"
                    className="search__datatable__input"
                    placeholder="Procurar"
                    onChange={searchHandler}
                  />
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <span
                    onClick={handleOpenPrecarioDialog}
                    title="Imprimir Preçário"
                    className="datatableTratamentos__printButton"
                  >
                    <Printer size={18} />
                  </span>
                  <span
                    className="blue-button"
                    onClick={() => navigate("/tratamentos/new")}
                  >
                    Adicionar Tratamento
                  </span>
                </div>
              </div>
            )}

            <DataGrid
              autoWidth
              className="datagrid"
              rows={data}
              columns={tratamentoColumns.concat(actionColumn)}
              pageSize={9}
              rowsPerPageOptions={[9]}
            />
          </div>
        </>
      )}
      {precarioConfig.showPdf && allData && (
        <PdfPrecario
          tratamentos={allData}
          /* A unidade da SESSÃO, não a de um registo. Ao contrário de uma
             fatura, o preçário não pertence a documento nenhum: é o catálogo
             da unidade onde se está a trabalhar, e esta página só mostra os
             tratamentos dessa. Os preços variam entre unidades, por isso um
             preçário com a morada da sede e os preços do outro balcão seria
             um papel que se entrega ao paciente a dizer a coisa errada. */
          clinica={dadosImpressao(clinica.clinica, auth.estabelecimento)}
          data={precarioConfig.data}
          instituicaoId={precarioConfig.instituicao}
          instituicoes={instituicoes}
          onClose={() =>
            setPrecarioConfig((prev) => ({ ...prev, showPdf: false }))
          }
        />
      )}

      <Dialog open={openPrecarioDialog} onClose={handleClosePrecarioDialog}>
        <DialogTitle>Configurar Preçário</DialogTitle>
        <DialogContent style={{ minWidth: "400px", paddingTop: "20px" }}>
          <TextField
            fullWidth
            label="Data do Preçário"
            type="date"
            value={precarioConfig.data}
            onChange={(e) =>
              setPrecarioConfig((prev) => ({ ...prev, data: e.target.value }))
            }
            InputLabelProps={{ shrink: true }}
            style={{ marginBottom: "20px" }}
          />

          <TextField
            fullWidth
            select
            label="Tipo de Preçário"
            value={precarioConfig.instituicao}
            onChange={(e) =>
              setPrecarioConfig((prev) => ({
                ...prev,
                instituicao: e.target.value,
              }))
            }
          >
            <MenuItem value="particular">Particular</MenuItem>
            {instituicoes.map((inst) => (
              <MenuItem key={inst.id} value={inst.id}>
                {inst.nome}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePrecarioDialog}>Cancelar</Button>
          <Button
            onClick={handleGeneratePrecario}
            variant="contained"
            color="primary"
          >
            Gerar PDF
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Datatable;
